import React from 'react';
import './playlist.css';
// import {read} from './database';
import VideoPlayer from './player';
import playlist from './tracks';
import {intervalStart, intervalEnd, fmtSeconds, playSound, bridgeCall} from './util';
const _ = require('lodash')

class Playlist extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      videos: [],
      isPlaying: false,
      playerStates: {},
      currentVideoIdx: -1,
    }
    this.players = {}
  }

  async componentDidMount() {
    // let videos = await read('intervals/playlist')
    let videos = playlist
    videos = _.shuffle(videos)
    this.setState({videos})
    window.startPlayback = () => {
      this.playbackStarted = true
      if (this.loaded) { this.play() }
    }
    bridgeCall('webReady')
  }
  
  renderPlayers() {
    const w = window.innerWidth
    const h = .75 * w
    const visible = this.state.currentVideoIdx
    const players = this.state.videos.map((video, i) => 
      <div key={'player'+i} className="playerFrame"
        style={{ opacity: i === visible ? 1 : 0}}>
        <VideoPlayer video={video} 
          onReady={_.partial(this.onReady, i).bind(this)}
          onStateChange={_.partial(this.onPlayerStateChange, i).bind(this)}
        />
      </div>)
    return <div style={{width: w+'px', height: h+'px'}}>
      {players}
    </div>
  }

  onPlayerStateChange(playerIdx, state) {
    const playerStates = _.clone(this.state.playerStates)
    playerStates[playerIdx] = state
    this.setState({playerStates})
  }

  onReady(playerIdx, player) {
    console.log("Player", playerIdx, "ready!")
    this.players[playerIdx] = player    
    const videos = _.cloneDeep(this.state.videos)
    videos[playerIdx].ready = true
    this.setState({videos})
    if (this.isReady()) {
      setTimeout(this.allPlayersReady.bind(this), 10)
    }
  }

  preloadAllPlayers(startIdx) {
    if (!startIdx) {startIdx = 0}
    if (startIdx >= this.state.videos.length) { return }
    console.log("preloading player", startIdx)
    this.players[startIdx].preload(() => {
      this.preloadAllPlayers(startIdx + 1)
    })
  }


  allPlayersReady() {
    if (this.loaded) { return }

    this.loaded = true
    console.log("ALL PLAYERS READY")
    // this.startNextVideo()
    this.setState({currentVideoIdx: 0})
    if (this.playbackStarted) { this.play() }
    this.interval = setInterval(this.tick.bind(this), 100)
    this.preloadAllPlayers()
  }

  switchToVideo(idx, crossFadeDuration) {
    console.log("switch to video", idx)
    this.crossfading = false
    const oldPlayer = this.getPlayer()
    if (crossFadeDuration) {
      setTimeout(() => {
        console.log('pausing prev player')
        oldPlayer.reset()
      }, crossFadeDuration)  
    } else {
      console.log('pausing prev player')
      oldPlayer.reset()
    }
    this.setState({ currentVideoIdx: idx })
    const video = this.state.videos[idx]
    this.players[idx].seekTo(intervalStart(video.range))
    this.players[idx].play()
  }

  startNextVideo(crossFadeDuration) {
    const idx = (this.state.currentVideoIdx + 1) % this.state.videos.length
    this.switchToVideo(idx, crossFadeDuration)
  }

  startPrevVideo(crossFadeDuration) {
    const idx = (this.state.videos.length + this.state.currentVideoIdx - 1) % this.state.videos.length
    this.switchToVideo(idx, crossFadeDuration)
  }

  startNextVideoIfNeeded() {
    const idx = this.state.currentVideoIdx
    if (idx < 0) { return }

    const player = this.players[idx]
    const end = intervalEnd(this.state.videos[idx].range)
    const time = player.getCurrentTime()
    if (time > end - 2) {
      if (this.crossfading) { return }
      console.log("start crossfade")
      this.crossfading = true
      playSound('trackTransition')
      // this.startNextVideo(2000)
      setTimeout(() => {
        this.startNextVideo(2000)
      }, 1000)
    }
  }

  tick() {
    this.startNextVideoIfNeeded()
    this.updateCountdown()
    this.playSoundsIfNeeded()
  }

  isReady() {
    if (this.state.videos.length === 0) {return false}
    let ready = true
    _.each(this.state.videos, v => ready = ready && v.ready)
    return ready
  }

  isPlaying() {
    return this.state.isPlaying
  }

  playSoundsIfNeeded() {
    if (!this.state.workIntervalActive && 
        fmtSeconds(this.state.countdown) === '0:02') {
      playSound('start')
    }
    if (this.state.workIntervalActive && 
        fmtSeconds(this.state.countdown) === '0:00') {
      playSound('end')
    }
  }
  updateCountdown() {
    const idx = this.state.currentVideoIdx
    const time = this.players[idx].getCurrentTime()
    const intervals = _.map(this.state.videos[idx].intervals, i=>
      {return {start: intervalStart(i), end: intervalEnd(i)}})
    // find next uncompleted "on" interval
    const interval = _.find(intervals, i=>i.end >= time)
    if (!interval) {
      const remainingTrack = intervalEnd(this.state.videos[idx].range) - time
      const nextIdx = (idx + 1) % this.state.videos.length
      const nextTrackStart = intervalStart(this.state.videos[nextIdx].range)
      const firstInterval = this.state.videos[nextIdx].intervals[0]
      const nextTrackWork = intervalStart(firstInterval)
      const upNextIntervalLength = intervalEnd(firstInterval) - intervalStart(firstInterval)
      this.setState({
        upNextIntervalLength,
        countdown: remainingTrack + nextTrackWork - nextTrackStart, 
        workIntervalActive: false
      })
      return
    }
    if (time >= interval.start) {
      this.setState({
        countdown: interval.end - time,
        workIntervalActive: true
      })
    } else {
      this.setState({
        upNextIntervalLength: interval.end-interval.start,
        countdown: interval.start - time,
        workIntervalActive: false
      })
    }
  }

  getPlayer() {
    const idx = this.state.currentVideoIdx
    return this.players[idx]
  }

  play() {
    this.setState({isPlaying: true})
    this.playbackStarted = true
    this.getPlayer().play()
  }

  pause() {
    this.setState({isPlaying: false})
    this.getPlayer().pause()
  }

  hasNextTrack() {
    return this.state.currentVideoIdx < this.state.videos.length - 1
  }

  hasPrevTrack() {
    return this.state.currentVideoIdx > 0
  }

  nextTrack() {
    this.startNextVideo()
  }

  prevTrack() {
    this.startPrevVideo()
  }

  renderTrackInfo() {
    const idx = this.state.currentVideoIdx
    if (idx < 0) { return }
    const video = this.state.videos[idx]
    return <div className="trackInfo">
      <div className="title">{video.title}</div>
      <div className="artist">{video.artist}</div>
    </div>
  }

  renderUpNext() {
    return <div className="upnext" style={{
      opacity: this.state.workIntervalActive ? 0 : 1
    }}>
      up next: <span className="upnext-time">{fmtSeconds(this.state.upNextIntervalLength)} ON</span>
    </div>
  }

  renderCountdown() {
    if (isNaN(this.state.countdown)) { return null }
    const onrest = this.state.workIntervalActive ? 'On' : 'Rest'
    return <div className="countdown" style={{
      opacity: this.isPlaying() ? 1 : 0
    }}>
      <div className="instructions">{onrest} for</div>
      <div className="time">
        {fmtSeconds(this.state.countdown)}
      </div>
      {this.renderUpNext()}
    </div>
  }

  endWorkout() {
    bridgeCall('endWorkout')
  }

  renderEndWorkout() {
    return <div className="endworkout" style={{
      opacity: this.isPlaying() ? 0 : 1
    }}>
      <div className="endworkout-button" onClick={this.endWorkout.bind(this)}> 
        End Workout
      </div>
    </div>
  }

  renderControls() {
    window.play = this.play.bind(this)
    window.next = this.nextTrack.bind(this)
    return <div className="controls" onTouchStart={()=>{}}>
      <div className="prev" onClick={this.prevTrack.bind(this)}></div>
      {this.isPlaying() ? 
        <div className="pause" onClick={this.pause.bind(this)}></div> : 
        <div className="play" onClick={this.play.bind(this)}></div>}
      <div className="next" onClick={this.nextTrack.bind(this)}></div>
    </div>
  }

  render() {
    const players = this.renderPlayers()    
    return <div className="interval-player">
        <div className="players">
          {players}
        </div>
        {this.isReady() ? <div className="container">
          {this.renderTrackInfo()}
          <div className="middleContainer">
            {this.renderCountdown()}
            {this.renderEndWorkout()}
          </div>
          {this.renderControls()}
        </div> : <div className="loading">
          Loading
        </div>}
      </div> 
  }
}

export default Playlist;